import script from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderLogo.vue?vue&type=style&index=0&id=c0c55d22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c55d22"]])

export default __exports__